import React, { Component } from 'react'
import numeral from 'numeral'
import { RefiTransactionsCard as LienholderCard } from '../../refiTransactions/refiTransactionsCard'
import { RefiTransactionsRow as LienholderRow } from '../../refiTransactions/refiTransactionsRow'

import TaskPayoffDetails from '../taskPayoffDetails'
import { Task, LienholderInfo, PayoffAuthorization } from '../types'

export interface Props {
  task: Task
}

export default class Lienholder extends Component<Props> {
  static displayName = 'Lienholder'

  render() {
    const { task } = this.props
    const lienholder = task.verifiables[0] as LienholderInfo
    const payoff = task.verifiables[1] as PayoffAuthorization
    const {
      name,
      phoneNumber,
      accountNumber,
      submittedPayoffAmount,
      totalPayoffAmount,
    } = lienholder
    const { document } = payoff
    const { vehicle } = task

    const payoffText =
      task.taskType === 'CONTACT_LIENHOLDER'
        ? 'Submitted payoff amount'
        : 'Last verified total payoff'

    const payoffValue =
      task.taskType === 'CONTACT_LIENHOLDER'
        ? numeral(submittedPayoffAmount).format('$0,0')
        : numeral(totalPayoffAmount).format('$0,0')

    return (
      <div className="task-lienholder__body">
        <LienholderCard title="LIENHOLDER DETAILS">
          <LienholderRow field="Lienholder name" fieldsBold>
            {name}
          </LienholderRow>
          <LienholderRow field="Lienholder phone #" fieldsBold>
            {phoneNumber ? phoneNumber : null}
          </LienholderRow>
          <LienholderRow field="Lienholder account #" fieldsBold>
            {accountNumber ? accountNumber : null}
          </LienholderRow>
          <LienholderRow field={payoffText} fieldsBold>
            {payoffValue}
          </LienholderRow>
          <LienholderRow field="Estimated value" fieldsBold>
            {vehicle &&
              vehicle.latestValue &&
              numeral(vehicle.latestValue).format('$0,0')}
          </LienholderRow>
          <LienholderRow field="Payoff auth" fieldsBold>
            {document && (
              <a href={document.url} target="_blank">
                Link to doc
              </a>
            )}
          </LienholderRow>
        </LienholderCard>

        {task.status === 'APPROVED' && <TaskPayoffDetails task={task} />}
      </div>
    )
  }
}
